import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  standalone: false
})
export class NotFoundComponent {

  currentContent = 'not-found';
  menuItems = [
    { name: '404 Not Found', link: 'not-found', icon: 'exclamation-triangle' }
  ];

  constructor() { }

}
